import React from 'react';

const s = {
  page: { maxWidth: 480, margin: '80px auto', padding: '0 24px', textAlign: 'center' },
  box: { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: '32px 28px' },
  title: { fontSize: 20, fontWeight: 700, color: '#b91c1c', marginBottom: 10 },
  message: { fontSize: 14, color: '#7f1d1d', marginBottom: 20, lineHeight: 1.5 },
  btn: {
    background: '#1e40af', color: '#fff', border: 'none',
    fontWeight: 600, fontSize: 14, padding: '10px 22px',
    borderRadius: 8, cursor: 'pointer',
  },
};

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={s.page}>
          <div style={s.box}>
            <div style={s.title}>Something went wrong</div>
            <div style={s.message}>
              {this.state.error?.message || 'An unexpected error occurred.'}
            </div>
            <button style={s.btn} onClick={() => window.location.reload()}>
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
